export function getLandingSamplePlayUrl(template) {
  const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '') || '';

  if (!template?.campaignId) return '';
  return `${base}/p/${template.campaignId}`;
}

export function getLandingDemoPlayUrl(template) {
  return getLandingSamplePlayUrl(template);
}
